<template>
  <div id="system-config-modal" class="modal" v-show="modalShown" v-drag="{handle:'#modal-moving'}" style="position: fixed">
    <div class="modal-main" >
      <div class="title-area" id="modal-moving">
        <h2>システム設定</h2>
      </div>
      <div class="data-area">
        <div class="input-area left">
          <ul>
            <li>
              <span class="label">材料管理費率</span>
              <input type="number" v-model="syscfgMaterialMagProb" />%
            </li>
            <li>
              <span class="label">加工費 分レート</span>
              <input type="number" v-model="syscfgProcessCostMin" />円/分
            </li>
            <li>
              <span class="label">生産管理費率</span>
              <input type="number" v-model="syscfgProcessMagProb" />%
            </li>
            <li>
              <span class="label">工場利益率</span>
              <input type="number" v-model="syscfgProcessProfitProb" />%
            </li>
            <li>
              <span class="label">輸送賃</span>
              <input type="number" v-model="syscfgFacttransCost" />円
            </li>
            <!-- add DCD-464 start -->
            <li>
              <span class="label">施工人件費単価</span>
              <input type="number" v-model="syscfgExecutionCostPerson" />円/分
            </li>
            <li>
              <span class="label">施工駐車場単価</span>
              <input type="number" v-model="syscfgExecutionCostCar" />円/分
            </li>
            <li>
              <span class="label">施工費最低保証金額</span>
              <input type="number" v-model="syscfgExecutionCostMin" />円
            </li>
            <li>
              <span class="label">搬入人件費単価</span>
              <input type="number" v-model="syscfgMobilizationCostPerson" />円/分
            </li>
            <!-- add DCD-464 end -->
          </ul>
        </div>
        <div class="input-area">
          <div class="right">
            <ul>
              <li>
                原価積算
              </li>
              <li>
                <span class="label">営業部門 利益率</span>
                <input type="number" v-model="syscfgProfitRate1" />%
              </li>
              <li>
                <span class="label">販社A 利益率</span>
                <input type="number" v-model="syscfgProfitRate2" />%
              </li>
              <li>
                <span class="label">販社B 利益率</span>
                <input type="number" v-model="syscfgProfitRate3" />%
              </li>
              <li>
                <span class="label">販社C 利益率</span>
                <input type="number" v-model="syscfgProfitRate4" />%
              </li>
            </ul>
          </div>
          <div class="right">
            <ul>
              <li>
                設定上代
              </li>
              <li>
                <span class="label">定価</span>
                <input type="number" v-model="syscfgRegretRate4" />%
              </li>
              <li>
                <span class="label">掛率A</span>
                <input type="number" v-model="syscfgRegretRate3" />%
              </li>
              <li>
                <span class="label">掛率B</span>
                <input type="number" v-model="syscfgRegretRate2" />%
              </li>
              <li>
                <span class="label">掛率C</span>
                <input type="number" v-model="syscfgRegretRate1" />%
              </li>
            </ul>
          </div>
        </div>
      </div>
      <p class="error_message" v-for="(errorMessage, idx) in validateErrorMessages" :key="idx">
        {{errorMessage}}
      </p>
      <div class="button-area">
      <button type="button" class="main_btn" @click="updateSystemConfig">設定</button>
      <button type="button" class="main_btn" @click="onCancel">キャンセル</button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import * as Api from '../../utils/Api'
import * as AppUtil from '../../utils/App'
import {API_URL} from '../../constants/App'
export default {
  name: 'SystemConfigModal',
  props: {
    prevDialog: {
      type: Function,
      default: function () {}
    }
  },
  data () {
    return {
      /** モーダル開閉 */
      modalShown: false,
      /** システム設定 */
      syscfgMaterialMagProb: null,
      syscfgProcessCostMin: null,
      syscfgProcessMagProb: null,
      syscfgProcessProfitProb: null,
      syscfgFacttransCost: null,
      // add DCD-464 20230912 start
      syscfgExecutionCostPerson: null,
      syscfgExecutionCostCar: null,
      syscfgExecutionCostMin: null,
      syscfgMobilizationCostPerson: null,
      // add DCD-464 20230912 end
      syscfgProfitRate1: null,
      syscfgProfitRate2: null,
      syscfgProfitRate3: null,
      syscfgProfitRate4: null,
      syscfgRegretRate1: null,
      syscfgRegretRate2: null,
      syscfgRegretRate3: null,
      syscfgRegretRate4: null,
      validateErrorMessages: {}
    }
  },
  watch: {
    modalShown: function () {
      /** キャンバス内キーボード制御 */
      if (this.modalShown) {
        // this.$emit('onShowModal')
        document.addEventListener('keydown', this.onKeydown)
      } else {
        // this.$emit('onCloseModal')
        document.removeEventListener('keydown', this.onKeydown)
      }
    }
  },
  methods: {
    showModal: function () {
      this.modalShown = true
    },
    onCancel: function () {
      this.modalShown = false
      this.prevDialog()
    },
    updateSystemConfig: function () {
      this.validateErrorMessages = {}
      // 金額入力のバリデーションチェック
      let validList = []
      // 0以上であるか
      validList.push(this.validRate(this.syscfgMaterialMagProb, 'syscfgMaterialMagProb', '材料管理費率'))
      validList.push(this.validRate(this.syscfgProcessMagProb, 'syscfgProcessMagProb', '生産管理費率'))
      validList.push(this.validRate(this.syscfgProcessProfitProb, 'syscfgProcessProfitProb', '工場利益率'))
      validList.push(this.validRate(this.syscfgProfitRate1, 'syscfgProfitRate1', '営業部門 利益率'))
      validList.push(this.validRate(this.syscfgProfitRate2, 'syscfgProfitRate2', '販社A 利益率'))
      validList.push(this.validRate(this.syscfgProfitRate3, 'syscfgProfitRate3', '販社B 利益率'))
      validList.push(this.validRate(this.syscfgProfitRate4, 'syscfgProfitRate4', '販社C 利益率'))
      validList.push(this.validRate(this.syscfgProfitRate1, 'syscfgRegretRate1', '掛率C'))
      validList.push(this.validRate(this.syscfgProfitRate2, 'syscfgRegretRate2', '掛率B'))
      validList.push(this.validRate(this.syscfgProfitRate3, 'syscfgRegretRate3', '掛率A'))
      validList.push(this.validRate(this.syscfgProfitRate4, 'syscfgRegretRate4', '定価'))

      // 0以上かつ整数であるか
      validList.push(this.validCost(this.syscfgProcessCostMin, 'syscfgProcessCostMin', '加工費 分レート'))
      validList.push(this.validCost(this.syscfgFacttransCost, 'syscfgFacttransCost', '輸送費'))
      // add DCD-464 20230912 start
      validList.push(this.validCost(this.syscfgExecutionCostPerson, 'syscfgExecutionCostPerson', '施工人件費単価'))
      validList.push(this.validCost(this.syscfgExecutionCostCar, 'syscfgExecutionCostCar', '施工駐車場単価'))
      validList.push(this.validCost(this.syscfgExecutionCostMin, 'syscfgExecutionCostMin', '施工費最低保証金額'))
      validList.push(this.validCost(this.syscfgMobilizationCostPerson, 'syscfgMobilizationCostPerson', '搬入人件費単価'))
      // add DCD-464 20230912 end

      let isVarid = true
      validList.forEach(e => {
        if (!e) {
          isVarid = e
        }
      })
      if (!isVarid) { return }
      let payload = {
        syscfgMaterialMagProb: this.innerHangingToDouble(this.syscfgMaterialMagProb),
        syscfgProcessCostMin: this.syscfgProcessCostMin,
        syscfgProcessMagProb: this.innerHangingToDouble(this.syscfgProcessMagProb),
        syscfgProcessProfitProb: this.innerHangingToDouble(this.syscfgProcessProfitProb),
        syscfgFacttransCost: this.syscfgFacttransCost,
        // add DCD-464 20230912 start
        syscfgExecutionCostPerson: this.syscfgExecutionCostPerson,
        syscfgExecutionCostCar: this.syscfgExecutionCostCar,
        syscfgExecutionCostMin: this.syscfgExecutionCostMin,
        syscfgMobilizationCostPerson: this.syscfgMobilizationCostPerson,
        // add DCD-464 20230912 end
        syscfgProfitRate1: this.hangingToDouble(this.syscfgProfitRate1),
        syscfgProfitRate2: this.hangingToDouble(this.syscfgProfitRate2),
        syscfgProfitRate3: this.hangingToDouble(this.syscfgProfitRate3),
        syscfgProfitRate4: this.hangingToDouble(this.syscfgProfitRate4),
        syscfgRegretRate1: this.syscfgRegretRate1 / 100,
        syscfgRegretRate2: this.syscfgRegretRate2 / 100,
        syscfgRegretRate3: this.syscfgRegretRate3 / 100,
        syscfgRegretRate4: this.syscfgRegretRate4 / 100
      }
      axios.post(API_URL.ADMIN + '/update-system-conf', payload
      ).then(response => {
        let modalData = {
          messages: ['変更しました'],
          onOk: () => {
            this.modalShown = false
            this.prevDialog()
          }
        }
        this.validateErrorMessages = {}
        AppUtil.showModal(modalData)
      }).catch(error => {
        this.validateErrorMessages = {}
        Api.handleError(error, this.errorMessage, this.validateErrorMessages)
      })
    },
    getSystemConfig: function () {
      axios.get(API_URL.ADMIN + '/get-system-conf'
      ).then(response => {
        let data = response.data.data
        this.syscfgMaterialMagProb = this.innerHangingToPercent(data.syscfgMaterialMagProb)
        this.syscfgProcessCostMin = data.syscfgProcessCostMin
        this.syscfgProcessMagProb = this.innerHangingToPercent(data.syscfgProcessMagProb)
        this.syscfgProcessProfitProb = this.innerHangingToPercent(data.syscfgProcessProfitProb)
        this.syscfgFacttransCost = data.syscfgFacttransCost
        // add DCD-464 20230912 start
        this.syscfgExecutionCostPerson = data.syscfgExecutionCostPerson
        this.syscfgExecutionCostCar = data.syscfgExecutionCostCar
        this.syscfgExecutionCostMin = data.syscfgExecutionCostMin
        this.syscfgMobilizationCostPerson = data.syscfgMobilizationCostPerson
        // add DCD-464 20230912 end
        this.syscfgProfitRate1 = this.hangingToPercent(data.syscfgProfitRate1)
        this.syscfgProfitRate2 = this.hangingToPercent(data.syscfgProfitRate2)
        this.syscfgProfitRate3 = this.hangingToPercent(data.syscfgProfitRate3)
        this.syscfgProfitRate4 = this.hangingToPercent(data.syscfgProfitRate4)
        // mdf DCD-463 20230829 start
        // this.syscfgRegretRate1 = data.syscfgRegretRate1 * 100 // mdf DCD-463 20230829
        // this.syscfgRegretRate2 = data.syscfgRegretRate2 * 100 // mdf DCD-463 20230829
        // this.syscfgRegretRate3 = data.syscfgRegretRate3 * 100 // mdf DCD-463 20230829
        // this.syscfgRegretRate4 = data.syscfgRegretRate4 * 100 // mdf DCD-463 20230829
        this.syscfgRegretRate1 = Math.round(data.syscfgRegretRate1 * 100)
        this.syscfgRegretRate2 = Math.round(data.syscfgRegretRate2 * 100)
        this.syscfgRegretRate3 = Math.round(data.syscfgRegretRate3 * 100)
        this.syscfgRegretRate4 = Math.round(data.syscfgRegretRate4 * 100)
        // mdf DCD-463 20230829 end
      }).catch(error => {
        Api.handleError(error)
      })
    },
    /** 内掛けの掛率をdouble型表記から％表記に変換 */
    innerHangingToPercent: function (prob) {
      return Math.round((prob - 1) * 100)
    },
    /** 内掛けの掛率を%表記からdouble型表記に変換 */
    innerHangingToDouble: function (prob) {
      if (prob == null || prob === '') return prob
      return 1 + prob / 100
    },
    /** 外掛けの掛率をdouble型表記から％表記に変換 */
    hangingToPercent: function (prob) {
      return Math.round((1 - prob) * 100)
    },
    /** 外掛けの掛率を%表記からdouble型表記に変換 */
    hangingToDouble: function (prob) {
      if (prob == null || prob === '') return prob
      // return 1 - prob / 100 // mdf DCD-463 20230829
      let num = 1 - prob / 100
      return num.toFixed(2)
    },
    /** 掛率のバリデーションチェック（入力した値が0以上999以下であるか判定） */
    validRate: function (executionRate, key, errorMessage) {
      let pattern = /^([1-9]\d*|0)$/
      if (executionRate !== null && executionRate !== '' && (!pattern.test(executionRate) || String(executionRate).length > 3)) {
        this.$set(this.validateErrorMessages, key, errorMessage + 'は0以上999以下の整数で入力してください。')
        return false
      }
      this.$set(this.validateErrorMessages, key, '')
      return true
    },
    /** 価格のバリデーションチェック（入力した値が整数であるか判定） */
    validCost: function (executionCost, key, errorMessage) {
      let pattern = /^([1-9]\d*|0)$/
      if (executionCost !== null && executionCost !== '' && (!pattern.test(executionCost) || String(executionCost).length > 9)) {
        this.$set(this.validateErrorMessages, key, errorMessage + 'は0以上999999999以下の整数で入力してください。')
        return false
      }
      this.$set(this.validateErrorMessages, key, '')
      return true
    }
  },
  created: function () {
    this.getSystemConfig()
  }
}
</script>
<style lang="scss" scoped>
.modal {
  height: 95%;
  min-width: 800px;
}
li{
  margin-bottom: 20px;
  div{
    width: 175px;
    display: inline-block;
    padding: 10px;
    text-align: left;
  }
  .label{
    min-width: 160px;
    display: inline-block;
    text-align: left;
    font-weight: bold;
  }
  input {
    width: 80px;
    text-align: right;
  }
}
.data-area {
  padding: 15px;
  max-height: 620px;
  overflow: hidden;
  .input-area {
    float: left;
    padding: 15px;
  }
  .left {
    padding: 50px 30px;
  }
  .right {
    padding: 15px;
    margin: 10px 0;
    font-weight: bold;
    border: solid 2px #888888;
  }
}
.modal-main{
  max-height: 97%;
  max-width: 760px;
}
.count_limit{
  font-size: 8px;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/common/SystemConfigModal.vue